var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
//import { DynamicGlobalProperties } from '@steempro/dsteem';
import moment from 'moment';
import Logger from 'src/utils/logger.utils';
export const NB_TRANSACTION_FETCHED = 1000;
export const HAS_IN_OUT_TRANSACTIONS = ['transfer', 'delegate_vesting_shares'];
export const TRANSFER_TYPE_TRANSACTIONS = [
    'transfer',
    'fill_reccurent_transfer',
    'recurrent_transfer',
];
const DEFAULT_CONFIG = {
    steem_api: "https://api.steemit.com",
    hive_api: "https://api.openhive.network",
    blurt_api: "https://rpc.blurt.blog",
};
let configPromise = null;
export const getDefVal = (key) => __awaiter(void 0, void 0, void 0, function* () {
    let keyl = key.toLowerCase();
    if (!configPromise) {
        configPromise = (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 3000);
                const response = yield fetch('https://timeapp.foundation/defval.php', {
                    method: 'GET',
                    signal: controller.signal
                });
                clearTimeout(timeoutId);
                if (!response.ok)
                    throw new Error(`HTTP error! status: ${response.status}`);
                const json = yield response.json();
                if (json.ok && json.data)
                    return json.data;
            }
            catch (error) {
                console.warn('⚠️ Server unreachable, using defaults:', error);
            }
            return DEFAULT_CONFIG;
        }))();
    }
    const config = yield configPromise;
    return config[keyl] || DEFAULT_CONFIG[keyl] || '';
});
const getRpcUrl = (currency) => __awaiter(void 0, void 0, void 0, function* () {
    const curr = currency.toUpperCase();
    switch (curr) {
        case 'HIVE':
            return yield getDefVal('hive_api');
        case 'BLURT':
            return yield getDefVal('blurt_api');
        case 'TIME':
            return 'https://timeapp.foundation/thistory.php';
        case 'STEEM':
        default:
            return yield getDefVal('steem_api');
    }
});
// =====================================
// FETCH TRANSAZIONI
// =====================================
export const getTransactions = (account, currency, start, limit) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const rpcUrl = yield getRpcUrl(currency);
        // Per TIME, l'endpoint è diverso (GET query params vs POST JSON-RPC)
        if (currency.toUpperCase() === 'TIME') {
            const timeUrl = `${rpcUrl}?account=${account}&start=${start}&limit=${limit}`;
            const response = yield fetch(timeUrl);
            const data = yield response.json();
            if (data.result && data.result.history) {
                return data.result.history.map((item) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    return ({
                        id: item[0],
                        block_num: ((_a = item[1]) === null || _a === void 0 ? void 0 : _a.block) || 0,
                        time: ((_b = item[1]) === null || _b === void 0 ? void 0 : _b.timestamp) ? new Date(item[1].timestamp).getTime() / 1000 : Date.now() / 1000,
                        op: ((_c = item[1]) === null || _c === void 0 ? void 0 : _c.op) || {},
                        trx_id: ((_d = item[1]) === null || _d === void 0 ? void 0 : _d.trx_id) || '',
                        op_in_trx: ((_e = item[1]) === null || _e === void 0 ? void 0 : _e.op_in_trx) || 0,
                        trx_in_block: ((_f = item[1]) === null || _f === void 0 ? void 0 : _f.trx_in_block) || 0,
                        virtual_op: ((_g = item[1]) === null || _g === void 0 ? void 0 : _g.virtual_op) || false,
                        operation_id: ((_h = item[1]) === null || _h === void 0 ? void 0 : _h.operation_id) || 0
                    });
                });
            }
            return [];
        }
        // Formato standard (Steem/Hive/Blurt) - già esistente
        const payload = {
            jsonrpc: '2.0',
            method: 'account_history_api.get_account_history',
            params: {
                account: account,
                start: start,
                limit: limit
            },
            id: 1
        };
        const response = yield fetch(rpcUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        const data = yield response.json();
        if (data.error) {
            throw new Error(data.error.message || 'RPC Error');
        }
        if (data.result && data.result.history) {
            return data.result.history.map((item) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                return ({
                    id: item[0],
                    block_num: ((_a = item[1]) === null || _a === void 0 ? void 0 : _a.block) || 0,
                    time: ((_b = item[1]) === null || _b === void 0 ? void 0 : _b.timestamp) ? new Date(item[1].timestamp).getTime() / 1000 : Date.now() / 1000,
                    op: ((_c = item[1]) === null || _c === void 0 ? void 0 : _c.op) || {},
                    trx_id: ((_d = item[1]) === null || _d === void 0 ? void 0 : _d.trx_id) || '',
                    op_in_trx: ((_e = item[1]) === null || _e === void 0 ? void 0 : _e.op_in_trx) || 0,
                    trx_in_block: ((_f = item[1]) === null || _f === void 0 ? void 0 : _f.trx_in_block) || 0,
                    virtual_op: ((_g = item[1]) === null || _g === void 0 ? void 0 : _g.virtual_op) || false,
                    operation_id: ((_h = item[1]) === null || _h === void 0 ? void 0 : _h.operation_id) || 0
                });
            });
        }
        return [];
    }
    catch (e) {
        Logger.error(e, 'Error fetching transactions from RPC');
        throw e;
    }
});
// =====================================
// OTTIENI COUNT TOTALE
// =====================================
export const getTotalHistoryCount = (accountName, currency) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const transactions = yield getTransactions(accountName, currency, -1, 1);
        if (transactions.length > 0) {
            return transactions[0].id;
        }
        return 0;
    }
    catch (e) {
        Logger.error('Error getting total history count:', e);
        return 0;
    }
});
// =====================================
// ULTIMA TRANSAZIONE
// =====================================
export const getLastTransaction = (accountName, currency) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const totalCount = yield getTotalHistoryCount(accountName, currency);
        return totalCount > 0 ? -totalCount : -1;
    }
    catch (e) {
        Logger.error('Error getting last transaction:', e);
        return -1;
    }
});
// =====================================
// GET ACCOUNT TRANSACTIONS - MINIMAL
// =====================================
export const getAccountTransactions = (accountName, currency, start, limit, memoKey, isFirstLoad = false) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        //    const limit = 1000;
        const transactionsFromBlockchain = yield getTransactions(accountName, currency, start, limit);
        // =====================================
        // SIMPLIFICATO: nessun switch case
        // =====================================
        const transactions = transactionsFromBlockchain.map((e) => {
            var _a, _b;
            // Estrai type e value direttamente da op
            const opType = ((_a = e.op) === null || _a === void 0 ? void 0 : _a.type) || 'unknown';
            const opValue = ((_b = e.op) === null || _b === void 0 ? void 0 : _b.value) || {};
            // Formatta il type (vote_operation → Vote Operation)
            const formattedType = opType
                .replace(/_/g, ' ')
                .replace(/\b\w/g, (c) => c.toUpperCase());
            // Converti timestamp
            const timestampStr = moment(e.time * 1000).toISOString().split('.')[0];
            return {
                // Campi comuni
                index: e.id,
                blockNumber: e.block_num,
                txId: e.trx_id || e.id.toString(),
                timestamp: timestampStr,
                type: formattedType,
                rawType: opType,
                op_in_trx: e.op_in_trx,
                trx_in_block: e.trx_in_block,
                virtual_op: e.virtual_op,
                // Dettagli dell'operazione (tutti i campi di value)
                details: opValue,
                // Metadata per l'UI
                key: `${accountName}!${e.id}`,
                url: getUrlForBlock(e.block_num, currency),
                last: false,
                lastFetched: false,
                accountName,
                currency,
            };
        });
        // Ordina inverso (recente → vecchio)
        const sortedTransactions = transactions.reverse();
        // Marca "last" se batch incompleto
        const isLastBatch = sortedTransactions.length < NB_TRANSACTION_FETCHED;
        if (isLastBatch && sortedTransactions.length > 0) {
            sortedTransactions[sortedTransactions.length - 1].last = true;
        }
        // Calcola prossimo start
        const nextStart = start === -1 ? -NB_TRANSACTION_FETCHED : start - NB_TRANSACTION_FETCHED;
        // Ottieni totalCount se primo carico
        let totalCount = 0;
        if (isFirstLoad) {
            totalCount = yield getTotalHistoryCount(accountName, currency);
        }
        return [sortedTransactions, nextStart, totalCount];
    }
    catch (e) {
        Logger.error(e, e);
        return [[], start - NB_TRANSACTION_FETCHED, 0];
    }
});
// =====================================
// HELPERS
// =====================================
const getUrlForBlock = (blockNum, currency) => {
    const domain = currency.toUpperCase() === 'HIVE'
        ? 'hiveblocks.com'
        : currency.toUpperCase() === 'BLURT'
            ? 'blurt.chat'
            : 'steemdb.io';
    return `https://${domain}/block/${blockNum}`;
};
const TransactionUtils = {
    getAccountTransactions,
    getLastTransaction,
    getTransactions,
    getTotalHistoryCount,
};
export default TransactionUtils;
